import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-cart-delivery-page]';
const PLUGIN_NAME = 'CartDeliveryPage';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "plugin--cart-delivery-page" */ './cart-delivery-page'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/cart-delivery-page/index.js